export default __webpack_public_path__ + "static/media/hr2.213f4de7.png";